/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  checkNDCAndAddToDetailsTable,
  getAllLabelerList,
  getDrugListForLabeler,
  setLabelerDrugTableData,
  setLabelerTableData,
  setNDCErrorPopupMessage,
  setNDCLoading,
} from '../../store/action';
import MoveToDetailsIconContainer from '../MoveToDetailsIconContainer/MoveToDetailsIconContainer';
import NDCViewDetailsTable from '../NDCViewDetailsTable/NDCViewDetailsTable';
import LabelerDrugTable from './LabelerDrugTable';
import LabelerTableComponent from './LabelerTableComponent';

const NDCByLabeler = ({ fullScreen, setFullScreen, isViewNDCHidden }) => {
  const dispatch = useDispatch();
  const [drugTableRow, setDrugTableRow] = useState([]);
  const [labelerRow, setLabelerRow] = useState(null);
  const [gridApi, setGridApi] = useState(null);
  const [LTGrid, setLTGrid] = useState(false);
  const [grid1, setGrid1] = useState(false);
  const [grid2, setGrid2] = useState(false);

  const labelerDrugTableData = useSelector(
    (state) => state.sharedState.ndc.labelerDrugTableData
  );
  const labelerTableData = useSelector(
    (state) => state.sharedState.ndc.labelerTableData
  );
  const [gridDisplayMatrix, setGridDisplayMatrix] = useState({
    LTGridDisplay: true,
    grid1Display: true,
    grid2Display: true,
  });
  useEffect(() => {
    if (fullScreen == false) {
      setGridDisplayMatrix({
        LTGridDisplay: true,
        grid1Display: true,
        grid2Display: true,
      });
    }
  }, [fullScreen]);
  const handleFullScreenGird1 = () => {
    setGridDisplayMatrix({
      LTGridDisplay: false,
      grid1Display: true,
      grid2Display: false,
    });
    setFullScreen(!fullScreen);
  };
  const handleFullScreenGird2 = () => {
    setGridDisplayMatrix({
      LTGridDisplay: false,
      grid1Display: true,
      grid2Display: false,
    });
    setFullScreen(!fullScreen);
  };
  const handleLTGridFullScree = () => {
    setGridDisplayMatrix({
      LTGridDisplay: true,
      grid1Display: false,
      grid2Display: false,
    });
    setFullScreen(!fullScreen);
  };

  const addSingleRowToDetailsTable = () => {
    if (drugTableRow.length === 0) {
      dispatch(setNDCErrorPopupMessage('Please select from the drug names'));
    } else {
      dispatch(setNDCErrorPopupMessage(null));
      dispatch(checkNDCAndAddToDetailsTable(drugTableRow));
      gridApi.deselectAll();
    }
  };

  const addAllToDetailsTable = () => {
    if (labelerDrugTableData.length == 0) {
      dispatch(setNDCErrorPopupMessage('NDC not found'));
    } else {
      dispatch(setNDCErrorPopupMessage(null));
      dispatch(checkNDCAndAddToDetailsTable(labelerDrugTableData));
      gridApi.deselectAll();
    }
  };

  const getLabelerData = async () => {
    dispatch(setNDCLoading(true));
    const response = await getAllLabelerList();
    dispatch(setNDCLoading(false));
    if (!response) {
      dispatch(setNDCErrorPopupMessage('Labeler Not Found'));
    } else {
      dispatch(setNDCErrorPopupMessage(null));
    }

    dispatch(setLabelerTableData(response || []));
  };

  const callAndDataFromAPI = async () => {
    dispatch(setNDCLoading(true));
    const result = await getDrugListForLabeler({
      labelerCode: labelerRow.labelerCode,
      page: 1,
      pageSize: 100,
    });
    dispatch(setNDCLoading(false));

    dispatch(setLabelerDrugTableData(result || []));
  };

  useEffect(() => {
    if (labelerRow) {
      callAndDataFromAPI();
    }
  }, [labelerRow]);

  useEffect(() => {
    getLabelerData();
  }, []);

  return (
    <div className='my-4 container mx-0'>
      <div className='row'>
        {gridDisplayMatrix.LTGridDisplay && (
          <div className='col-12 p-0'>
            <LabelerTableComponent
              setLabelerRow={setLabelerRow}
              labelerTableData={labelerTableData}
              fullScreen={fullScreen}
              setFullScreen={handleLTGridFullScree}
            />
          </div>
        )}
      </div>
      <div className='row mt-4'>
        {gridDisplayMatrix.grid1Display ? (
          <div
            className={`${fullScreen ? 'col-12' : 'col-5'}  d-flex flex-column`}
            style={{ paddingTop: '40px' }}
          >
            <LabelerDrugTable
              labelerRow={labelerRow}
              labelerDrugTableData={labelerDrugTableData}
              setDrugTableRow={setDrugTableRow}
              gridApi={gridApi}
              setGridApi={setGridApi}
              fullScreen={fullScreen}
              setFullScreen={handleFullScreenGird1}
            />
          </div>
        ) : null}

        {!fullScreen ? (
          <div className='col-2 px-2'>
            <MoveToDetailsIconContainer
              handleSingleMove={() => addSingleRowToDetailsTable()}
              handleAllMove={() => addAllToDetailsTable()}
              handleRemove={() => {}}
            />
          </div>
        ) : null}

        {gridDisplayMatrix.grid2Display ? (
          <div
            className={`${fullScreen ? 'col-12' : 'col-5'}  d-flex flex-column`}
          >
            <NDCViewDetailsTable
              showFullScreen={false}
              isViewNDCHidden={isViewNDCHidden}
              fullScreen={fullScreen}
              setFullScreen={handleFullScreenGird2}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default NDCByLabeler;
